import { render, staticRenderFns } from "./descCard.vue?vue&type=template&id=57b96583"
import script from "./descCard.vue?vue&type=script&lang=js"
export * from "./descCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/frontend/components/kirbyimage.vue').default,Kirbylink: require('/opt/build/repo/frontend/components/kirbylink.vue').default})
